import React, { PropTypes } from 'react';
import styled from 'styled-components';
import { componentWithoutProps } from 'style-utils';

import { MenuLink } from './styles';

const SubMenuListContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
`;

const SubMenuListTitle = styled.p`
  margin: 0;
  font-family: ${props => props.theme.font.bold};
  letter-spacing: 1.5px;
  padding: 12px 0 12px ${props => props.iterate * 24}px;
`;

const SubMenuList = styled.ul`
  margin: 0;
  padding: 0;
`;

const SubMenuListItem = styled.li`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
`;

const SubMenuListLink = styled(({ active, iterate, ...rest }) => (
  <MenuLink {...rest} />
))`
  padding: 12px 0 12px ${props => props.iterate * 24}px;
  flex-grow: 1;
  background: ${props => (props.active ? '#051629' : '')};

  :hover {
    background: #051629;
  }
`;

/**
 * This component displays links in a nested structure to match the nesting of a given menu.
 */
const NestedMenuRoutes = ({
  menu,
  nestingLevel = 0,
  location,
  handleRoute,
  isAction
}) => {
  const paddingOffset = `12px 0 12px ${nestingLevel * 24}px`;
  const active = location.pathname.includes(menu.route);
  if (!menu.children || !menu.children.length) {
    const to = menu.route || menu.url;
    const target = menu.route ? null : '_blank';

    if (menu.metadata) {
      const menumeta = JSON.parse(menu.metadata);
      if (menumeta.force) {
        return (
          <SubMenuListLink
            style={{ padding: paddingOffset, cursor: 'pointer' }}
            active={active}
            href={to}
          >
            {menu.title}
          </SubMenuListLink>
        );
      }
    }

    if (isAction(menu)) {
      return (
        <SubMenuListLink
          style={{ padding: paddingOffset, cursor: 'pointer' }}
          active={active}
          onClick={() => handleRoute(menu)}
        >
          {menu.title}
        </SubMenuListLink>
      );
    }
    return (
      <SubMenuListLink
        to={to}
        target={target}
        active={active}
        style={{ padding: paddingOffset }}
      >
        {menu.title}
      </SubMenuListLink>
    );
  }

  const updatedIterate = nestingLevel + 1;

  return (
    <SubMenuListContainer>
      <SubMenuListTitle style={{ padding: paddingOffset }}>
        {menu.title}
      </SubMenuListTitle>
      <SubMenuList>
        {menu.children.map(subMenu => (
          <SubMenuListItem key={subMenu.id}>
            <NestedMenuRoutes
              menu={subMenu}
              nestingLevel={updatedIterate}
              isAction={isAction}
              location={location}
              handleRoute={handleRoute}
            />
          </SubMenuListItem>
        ))}
      </SubMenuList>
    </SubMenuListContainer>
  );
};

NestedMenuRoutes.propTypes = {
  // Details of the link to display and navigate to.
  menu: PropTypes.object.isRequired,

  // An offset multiplier for the corresponding level of menu nesting
  nestingLevel: PropTypes.number,

  // The react router current location
  location: PropTypes.shape({
    pathname: React.PropTypes.string.isRequired
  }).isRequired,

  // An optional function to act as a callback for when the route is clicked
  handleRoute: PropTypes.func
};

NestedMenuRoutes.defaultProps = {
  nestingLevel: 1,
  handleRoute: undefined
};

export default NestedMenuRoutes;



// WEBPACK FOOTER //
// ./src/components/common/Menu/Sidebar/NestedMenuRoutes.js